import * as React from 'react';
import { SVGProps } from 'react';

const IconBookStrokedSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.102 2.005A1 1 0 0 1 13 3v11a1 1 0 0 1-.898.995L12 15H4a1 1 0 0 1-.995-.898L3 14V3a1 1 0 0 1 1-1h8l.102.005ZM4 14h8v-1H6a1 1 0 1 1 0-2h6V3H8v6l-1.5-.857L5 9V3H4v11Z"
    />
  </svg>
);
export default IconBookStrokedSizeS;
